export enum TileType {
  Grass = 0,
  Water = 1,
  Forest = 2,
  Mountain = 3,
  Path = 4
}

export enum ActionType {
  Move = 'move',
  Interact = 'interact',
  Wait = 'wait'
}

export enum EntityType {
  Animal = 'animal',
  Plant = 'plant',
  Object = 'object'
}

export enum AnimalType {
  Wolf = 'wolf',
  Deer = 'deer',
  Rabbit = 'rabbit',
  Bear = 'bear',
  Bird = 'bird',
  Fish = 'fish'
}

export enum PlantType {
  Tree = 'tree',
  Flower = 'flower',
  Bush = 'bush',
  Grass = 'grass'
}

export enum BehaviorType {
  Random = 'random',          // Move randomly
  Wander = 'wander',          // Wander within a territory
  Predator = 'predator',      // Hunt prey animals
  Prey = 'prey',              // Run from predators
  Stationary = 'stationary',  // Doesn't move (plants, etc.)
  Flock = 'flock'             // Group behavior
}

export enum EmotionType {
  Hungry = 'hungry',
  Thirsty = 'thirsty',
  Tired = 'tired',
  Angry = 'angry',
  Stalking = 'stalking',
  Foraging = 'foraging',
  Biting = 'biting',
  Sleeping = 'sleeping',
  Frightened = 'frightened',
  Alert = 'alert',
  Curious = 'curious'
}